import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';
import Draggable, { DraggableData } from 'react-draggable';

import { Bem } from '../../service/Bem/Bem';
import { DocCenterContent } from '../DocCenterContent/DocCenterContent';
import { Loader } from '../Loader/Loader';

import './DraggableHelp.css';
import * as keyset from './DraggableHelp.i18n';
import { DraggableHelpHead } from './DraggableHelpHead/DraggableHelpHead';

const i18n = i18nFactory(keyset);

export interface DraggableHelpProps {
    isVisible: boolean;
    isProgress: boolean;
    onClose: () => void;

    text?: string;
}

interface DraggableHelpState {
    x: number;
    y: number;
}

const defaultPosition = {
    x: 0,
    y: 0
};

export class DraggableHelp extends React.PureComponent<DraggableHelpProps, DraggableHelpState> {
    constructor(props: DraggableHelpProps) {
        super(props);

        this.state = { ...defaultPosition };
    }

    render() {
        const { isVisible } = this.props;

        const handleClassName = Bem.cls('draggable-help', 'handle');

        return (
            <Draggable
                defaultPosition={{ x: 0, y: 0 }}
                position={this.state}
                defaultClassName={Bem.cls({
                    block: 'draggable-help',
                    mods: { visible: isVisible }
                })}
                defaultClassNameDragging={Bem.cls({
                    block: 'draggable-help',
                    mods: { dragging: true }
                })}
                defaultClassNameDragged={Bem.cls({
                    block: 'draggable-help',
                    mods: { dragged: true }
                })}
                handle={`.${handleClassName}`}
                onStop={this.onDragStop}
                bounds={'body'}
            >
                <div className={Bem.cls('draggable-help', 'content')}>
                    <DraggableHelpHead
                        title={i18n('help-title')}
                        handleClassName={handleClassName}
                        onClose={this.onDraggableClose}
                    />
                    {this.getContent()}
                </div>
            </Draggable>
        );
    }

    private getContent = (): React.ReactNode => {
        const { isProgress, text = '' } = this.props;

        if (isProgress) {
            return (
                <div className={Bem.cls('draggable-help', 'loader-wrapper')}>
                    <Loader size={'l'} />
                </div>
            );
        } else {
            return <DocCenterContent cls={Bem.cls('draggable-help', 'content-wrapper')} text={text} />;
        }
    };

    private onDragStop = (e: Event, data: DraggableData) => {
        this.setState({
            x: data.x,
            y: data.y
        });
    };

    private onDraggableClose = () => {
        const { onClose } = this.props;
        this.setState({ ...defaultPosition });
        onClose();
    };
}
